// extracted by mini-css-extract-plugin
module.exports = {"root":"banner-landing_root__2K-by"};